'use client';

import { c as _c } from "react/compiler-runtime";
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
import { useTranslations } from 'next-intl';
type ReportConfirmationModalProps = {
  open?: boolean;
  onAction?: () => void;
  container?: HTMLElement | null;
};
export default function ReportConfirmationModal(t0) {
  const $ = _c(15);
  const {
    open: t1,
    onAction,
    container
  } = t0;
  const open = t1 === undefined ? false : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== t) {
    t2 = t("report-confirmation-modal.title");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("report-confirmation-modal.description");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="body1-omni-styles text-vive-primary-20">{t3}</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("report-confirmation-modal.action");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== container || $[9] !== onAction || $[10] !== open || $[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <DefaultAlertDialog open={open} title={t2} container={container} content={t4} actionText={t5} onAction={onAction} allowOutsideInteraction={true} />;
    $[8] = container;
    $[9] = onAction;
    $[10] = open;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}